import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import AOS from "aos";  // Import AOS
import "aos/dist/aos.css";  // Import AOS styles


const BackgroundCircle = styled(Box)(() => ({
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "80%",
    backgroundColor: "#E3EBD4",
    borderRadius: "0 0 60% 60%",
    zIndex: -1, // Place it behind the image
}));

const ResponsiveImage = styled("img")(() => ({
    display: "block",
    width: "90%",
    maxWidth: "1200px", // Restrict maximum width for larger screens
    height: "auto", // Maintain aspect ratio
    margin: "50px auto", // Add top and bottom margins, center horizontally
    borderRadius: "16px", // Rounded corners
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Optional shadow for better aesthetics
}));

const ParagraphSection = styled(Box)(() => ({
    margin: "20px auto",
    padding: "20px",
    maxWidth: "1000px",
    textAlign: "center", // Center the text
}));

const SonXProductsSection = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 }); // Adjust duration as needed
    }, []);
    return (
        <>
            {/* Elliptical Background */}
            <BackgroundCircle data-aos="fade-up" />

            {/* Responsive Image */}
            <ResponsiveImage
                src="https://i.postimg.cc/8kMtXKHC/Frame-1265-3.png"
                alt="Responsive Design"
                data-aos="zoom-in"
            />

            {/* Paragraph Section */}
            <ParagraphSection>
                <Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: 2, color: "#98AF41",fontFamily: '"Montserrat", sans-serif', }}>
                    About Son-X Products
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8, color: "#98AF41" }}>
                    We proudly own and market our brand, Son X. With an extensive product portfolio, we offer essential commodities such as coconut oil, olive oil, tamarind, vegetable pickles, lemon pickles, and mango pickles, as well as hand wash and dish wash liquids.
                </Typography>
            </ParagraphSection>
        </>
    );
};

export default SonXProductsSection;
